import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};
export const Collect = ({ size = 4, className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="20"
      viewBox="0 0 39 20"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
    >
      <g>
        <path
          d="M30.6445 2.45879C30.6923 1.60645 31.5768 1.06562 32.3572 1.4108L37.9771 3.8984C38.4583 4.11151 38.7489 4.60859 38.6978 5.13251V5.13361L37.3761 18.7082C37.3092 19.398 36.6811 19.8937 35.9947 19.7994L30.8389 19.0882C30.2092 19.0011 29.7511 18.4451 29.7865 17.8103L30.6445 2.45879ZM6.34237 1.36206C7.12501 1.01572 8.01231 1.56154 8.05561 2.41614V2.4167L8.83606 17.7638C8.86867 18.3963 8.4111 18.9484 7.78364 19.035L2.62953 19.7457C1.94031 19.8406 1.31106 19.341 1.24753 18.6478L0.00511754 5.07601C-0.0426729 4.55425 0.24783 4.06051 0.726859 3.84855L6.34237 1.36206ZM25.5685 0.000553907C26.2689 0.000652659 26.8246 0.588023 26.7871 1.28673L25.8626 18.3332C25.8271 18.9802 25.2916 19.487 24.6435 19.487H13.8185C13.1658 19.4869 12.6285 18.9732 12.5993 18.321L11.8349 1.27509C11.804 0.580198 12.3592 0 13.0546 0H25.5685V0.000553907ZM17.7822 7.131L14.3181 7.65611L16.8129 10.1238L16.2407 13.5912L19.3514 11.9733L22.4611 13.5901L21.8889 10.1238L24.3842 7.65611L20.9196 7.131L19.3509 3.98869L17.7822 7.131Z"
          fill="url(#cardGradient)"
        />
        <path
          d="M30.8438 2.46973C30.8839 1.75716 31.6238 1.30511 32.2764 1.59375L37.8965 4.08105C38.2988 4.25934 38.5417 4.67539 38.499 5.11328V5.11426L37.1768 18.6885C37.1209 19.2649 36.5963 19.6801 36.0225 19.6016L30.8662 18.8896C30.3396 18.8167 29.9567 18.3519 29.9863 17.8213L30.8438 2.46973ZM6.42285 1.54395C7.07718 1.25439 7.81896 1.71166 7.85547 2.42578V2.42676L8.63672 17.7744C8.6638 18.3029 8.28057 18.7645 7.75586 18.8369L2.60254 19.5479C2.02633 19.6272 1.49954 19.2093 1.44629 18.6299L0.204102 5.05762C0.164223 4.62148 0.40711 4.20851 0.807617 4.03125L6.42383 1.54492L6.42285 1.54395ZM13.0547 0.200195H25.5684C26.154 0.200278 26.6183 0.692047 26.5869 1.27637L25.6631 18.3223C25.6334 18.8632 25.1855 19.287 24.6436 19.2871H13.8184C13.2728 19.287 12.8235 18.8576 12.7988 18.3125L12.0352 1.2666C12.0093 0.685551 12.4731 0.200195 13.0547 0.200195ZM19.1719 3.89941L17.6494 6.94824L14.2881 7.45801L13.8945 7.51855L14.1777 7.79785L16.5977 10.1924L16.043 13.5586L15.9785 13.9531L16.333 13.7686L19.3506 12.1982L22.3691 13.7676L22.7236 13.9521L22.6582 13.5576L22.1025 10.1924L24.5244 7.79785L24.8086 7.51855L24.4141 7.45801L21.0518 6.94824L19.5303 3.89941L19.3506 3.54102L19.1719 3.89941Z"
          stroke="url(#cardFooterGradient)"
          strokeOpacity="0.3"
          strokeWidth="0.4"
        />
      </g>
      <defs>
        <linearGradient
          id="cardGradient"
          x1="19.3518"
          y1="8.05796"
          x2="19.3518"
          y2="22.9177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A2F3" />
          <stop offset="1" stopColor="#7D41FF" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="cardFooterGradient"
          x1="20.3262"
          y1="19.8109"
          x2="20.3262"
          y2="-1.73626"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.216346" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
